module.exports = __webpack_public_path__ + "cd5f1248d33487b841dfcd367e6ff3e4.MP3";